import { CheckCircle2, MapPin, Calendar, Users, Award } from "lucide-react";

const ABOUT_IMG =
  "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200";

const badges = [
  { Icon: Calendar, label: "Founded in 2015" },
  { Icon: MapPin, label: "Mumbai Based" },
  { Icon: Users, label: "Full-Service Agency" },
  { Icon: Award, label: "Trusted Partner" },
];

const reasons = [
  {
    title: "10+ Years of Experience",
    desc: "Delivering quality digital solutions since 2015.",
  },
  {
    title: "Professional Team",
    desc: "Experienced developers, designers, and digital experts.",
  },
  {
    title: "Live Streaming Expertise",
    desc: "Professional streaming solutions for corporate and public events.",
  },
  {
    title: "Client-Focused Approach",
    desc: "Customized solutions tailored to business goals.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-20 md:py-32 px-5 sm:px-6 md:px-10 border-t border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-8 md:gap-10 items-center">
          <div className="col-span-12 md:col-span-6 relative">
            <div className="relative overflow-hidden border border-white/10">
              <img
                src={ABOUT_IMG}
                alt="Team collaboration at Mahaview Enterprises"
                className="w-full h-[280px] sm:h-[360px] md:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent" />
            </div>
            <div
              data-testid="about-badge"
              className="absolute -bottom-4 right-3 md:-bottom-6 md:-right-6 bg-[#FF5A00] text-white px-5 py-4 md:px-6 md:py-5 flex flex-col items-start"
            >
              <div className="font-display text-3xl md:text-4xl font-semibold leading-none">10<span>+</span></div>
              <div className="text-[9px] md:text-[10px] uppercase tracking-[0.2em] md:tracking-[0.25em] mt-2 opacity-90 whitespace-nowrap">Years of Excellence</div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-6 min-w-0">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-4 md:mb-5">/ About Us</div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-[56px] font-semibold leading-[1.1] tracking-tight mb-5 md:mb-6 break-words">
              About <span className="text-stroke">Mahaview</span> Enterprises
            </h2>
            <p className="text-zinc-300 text-sm sm:text-base leading-relaxed mb-4">
              Mahaview Enterprises is a Mumbai-based digital solutions company established in 2015.
              We specialise in <span className="text-white">Web Development</span>,{" "}
              <span className="text-white">Social Media Management</span>,{" "}
              <span className="text-white">Live Streaming</span>, and{" "}
              <span className="text-white">Graphic Designing</span>.
            </p>
            <p className="text-zinc-400 text-sm sm:text-base leading-relaxed mb-8">
              Our mission is to help businesses build a powerful online presence through innovative
              technology and creative solutions — combining strategy, design, and engineering under
              one roof.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
              {badges.map((b) => (
                <div
                  key={b.label}
                  data-testid={`about-badge-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex items-center gap-3 border border-white/10 px-4 py-3 bg-white/[0.02] min-w-0"
                >
                  <b.Icon size={16} className="text-[#FF5A00] flex-shrink-0" strokeWidth={1.5} />
                  <span className="text-sm text-zinc-200 truncate">{b.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="mt-20 md:mt-32">
          <div className="grid grid-cols-12 gap-6 mb-10 md:mb-12">
            <div className="col-span-12 md:col-span-8">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-4 md:mb-5">/ Why Choose Us</div>
              <h3 className="font-display text-3xl sm:text-4xl md:text-5xl font-semibold leading-[1.05] tracking-tight break-words">
                Why businesses trust <span className="text-[#FF5A00]">Mahaview</span>.
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {reasons.map((r, i) => (
              <div
                key={r.title}
                data-testid={`why-card-${i}`}
                className="mv-card p-6 md:p-8 flex flex-col gap-4 min-w-0"
              >
                <CheckCircle2 size={22} className="text-[#FF5A00]" strokeWidth={1.5} />
                <h4 className="font-display text-lg sm:text-xl font-medium tracking-tight">{r.title}</h4>
                <p className="text-sm text-zinc-400 leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
